import { setLoadingEvent } from './utility';

export default function opening() {
  const $opening = $('.p-opening');
  let waitValue = 500 + 4000;
  let startTime;

  if ($opening.length === 0) return;

  setLoadingEvent($opening, () => {
    startTime = new Date().getTime();
    $opening.addClass('_ready');
    setTimeout(() => {
      $opening.addClass('_animation');
    }, 500);
    setLoadingEvent($('body'), () => {
      waitValue -= new Date().getTime() - startTime;
      if (waitValue < 0) {
        waitValue = 0;
      }
      setTimeout(() => {
        $opening.addClass('_animationEnd');
        document.cookie = 'oneTimeOpening=show; path=/; samesite=lax';
        setTimeout(() => {
          $opening.addClass('_end');
          $opening.trigger('openingComplete');
        }, 1000);
      }, waitValue);
    });
  });
}
